import { __decorate } from "tslib";
import duration from '@/filters/duration.js';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { modalMixins } from '@/mixins/modal.js';
import { mapActions, mapGetters } from 'vuex';
import Money from "@/components/Money.vue";
import Modal from "@/components/Modal.vue";
import Avatar from '@/components/Avatar.vue';
import MoneyField from '@/components/MoneyField.vue';
import QuantityField from '@/components/QuantityField.vue';
import TeamSelect from '@/components/TeamSelect.vue';
import ConfirmationModal from '@/components/ConfirmationModal.vue';
import AddItemModal from '@/Pages/Appointments/AddItemModal.vue';
import DatePicker from "@/components/DatePicker.vue";
import PaymentResultForm from "./PaymentResultForm.vue";
import CustomSwitch from "@/components/CustomSwitch.vue";
import AppointmentNotification from "@/components/TimeTemplates/AppointmentNotification.vue";
import DiscountField from "./DiscountField.vue";
import Payments from "./Payments.vue";
import UserComponent from "@/components/User.vue";
import { DiscountMeasure, PaymentMethod } from '@/model-types/invoice';
import InvoiceModal from "@/Pages/Sales/InvoiceModal.vue";
let dataDefaults = {
    appointmentId: '',
    customerId: '',
    pricing: { discount: 0, products: 0, services: 0 },
    discount: { value: 0, measure: DiscountMeasure.percent },
    services: [],
    payments: [],
    totalPaid: 0,
    totalPrice: 0,
};
let CheckoutModal = class CheckoutModal extends Vue {
    id;
    calendarOptions = {
        wrap: true,
        altFormat: 'F j, Y',
        altInput: true,
        dateFormat: 'Y-m-d',
        minDate: new Date(),
    };
    inDebt = false;
    debtReturn = { date: null, text: null, timeTemplate: {}, notify: false };
    diffPayment = 0;
    totalPayment = 0;
    newBalance = 0;
    paymentList = [];
    currentItemIndex = 0;
    customer = {};
    title = 'Checkout';
    data = dataDefaults;
    teamIds = [];
    errors = {};
    tab = 'SERVICES';
    updateAppointment;
    updateCustomer;
    fetchCustomerCart;
    removeFromCart;
    create;
    getCustomerCart;
    openModal;
    invoiceModal;
    calcNewBalance() {
        let result = this.diffPayment + this.customerBalance;
        let balancePayment = this.paymentList.find(el => el.paymentMethod === PaymentMethod.userBalance);
        if (!balancePayment)
            return result;
        return result - balancePayment.toPay;
    }
    paymentListHandler(items) {
        this.totalPayment = this.paymentsSum(items);
        this.diffPayment = this.totalPayment - this.data.totalPrice;
        this.newBalance = this.calcNewBalance();
    }
    discountWatcher() {
        this.recalculateTotal();
    }
    servicesWatcher() {
        this.recalculateTotal();
    }
    get cartQuery() {
        let query = { customerId: this.data.customerId };
        if (this.teamIds && this.teamIds.length)
            query.userId = { $in: this.teamIds };
        return { query };
    }
    get customerBalance() {
        return this.customer.balance;
    }
    get userSelected() {
        if (!this.data.services)
            return false;
        return this.data.services.every((el) => el.userId);
    }
    printPreview() {
        let previewData = {
            appointmentId: this.data.appointmentId,
            customerId: this.data.customerId,
            services: this.data.services,
            totalPrice: this.data.totalPrice,
            totalPaid: this.totalPayment,
            pricing: this.data.pricing,
            discount: this.data.discount,
            payments: this.paymentList,
        };
        this.invoiceModal(null, true, true, previewData);
    }
    paymentsSum(payments) {
        return payments.reduce((total, item) => total + item.toPay, 0);
    }
    addItem(data) {
        let service = this.$copy(data);
        const length = this.data.services.length;
        if (length >= 1) {
            const lastService = this.data.services[length - 1];
            service.userId = lastService.userId;
        }
        this.data.services.push(service);
        this.currentItemIndex = length - 1;
    }
    removeItem(index) {
        this.data.services.splice(index, 1);
        setTimeout(() => {
            this.currentItemIndex = this.data.services.length - 1;
        }, 10);
    }
    hidden() {
        this.data = dataDefaults;
        this.inDebt = false;
        this.paymentList = [];
        this.debtReturn = { date: null, text: null, notify: false, timeTemplate: {} };
        this.diffPayment = 0;
        this.totalPayment = 0;
        this.paymentList = [];
        this.currentItemIndex = 0;
        this.teamIds = [];
    }
    shown() {
        this.errors = {};
        this.paymentList = [];
        const { Appointment } = this.$FeathersVuex;
        let data = Appointment.getFromStore('temp');
        if (data) {
            delete data._id;
            let appointment = this.$copy(data['appointment']);
            let appointmentId = appointment._id;
            delete appointment._id;
            // if the setting is enabled (appointmentService not required) do not add appointment services to invoice
            if (!this.$settings.appointmentServiceRequired)
                appointment.services = [];
            this.data = { ...appointment, appointmentId };
            this.customer = appointment.customer;
            if (data.teamIds)
                this.teamIds = this.$copy(data.teamIds);
            new Appointment({
                model: {},
                _id: 'temp'
            });
        }
        //Load data from cart
        this.fetchCustomerCart(this.cartQuery).then(result => {
            result.data.forEach((item) => {
                this.data.services.push({
                    duration: item.treatments.duration || 0,
                    quantity: item.quantity || 1,
                    treatment: item.treatments,
                    treatmentId: item.treatments._id,
                    user: item.user,
                    userId: item.userId,
                    tooths: item.tooths
                });
            });
        });
        this.$set(this.data, 'discount', { measure: '%', value: 0 });
        this.data.pricing = { services: 0, products: 0, discount: 0 };
        if (this.customer.discountPercent)
            this.$set(this.data, 'discount', { measure: '%', value: this.customer.discountPercent });
        this.recalculateTotal();
    }
    close() {
        this.$root.$emit('bv::hide::modal', this.id);
        this.inDebt = false;
    }
    complete() {
        let invoice = {
            appointmentId: this.data.appointmentId,
            customerId: this.data.customerId,
            services: this.data.services,
            totalPrice: this.data.totalPrice,
            totalPaid: this.totalPayment,
            pricing: this.data.pricing,
            discount: this.data.discount,
            payments: this.paymentList,
        };
        this.create(invoice).then(result => {
            let details = {
                customer: this.customer,
                invoice: result,
                _id: 'temp'
            };
            let cart = this.getCustomerCart(this.cartQuery).data;
            if (cart.length > 0) {
                cart.forEach((cartItem) => {
                    this.removeFromCart(cartItem._id);
                });
            }
            const { Invoice } = this.$FeathersVuex;
            new Invoice(details);
            this.close();
            this.openModal({ id: 'PaymentResultForm' });
        }).catch((err) => {
            this.errors = err.errors;
        });
        this.updateCustomer([this.data.customerId, { debtReturn: this.debtReturn }, {}]);
    }
    validation(field) {
        if (this.errors && this.errors[field])
            return false;
        else
            return null;
    }
    recalculateTotal() {
        let totalPrice = 0;
        let pricing = {
            services: 0,
            products: 0,
            discount: 0
        };
        let services = this.$copy(this.data.services);
        services.forEach((item) => {
            let price = 0;
            let quantity = item.quantity || 1;
            if (item.treatment) {
                price = item.treatment.price || 0;
                price *= quantity;
                pricing.services += price;
            }
            else if (item.product) {
                price = (item.product.price || { retailPrice: 0 }).retailPrice;
                price *= quantity / (item.product.perServing || 1);
                pricing.products += price;
            }
            totalPrice += price;
        });
        if (this.data.discount) {
            let discount = this.data.discount.value;
            if (this.data.discount.measure === '$') {
                pricing.discount = discount;
            }
            else {
                pricing.discount = (discount * totalPrice) / 100;
            }
            totalPrice = totalPrice - pricing.discount;
        }
        this.$set(this.data, 'totalPrice', totalPrice);
        this.$set(this.data, 'pricing', pricing);
    }
};
__decorate([
    Prop({})
], CheckoutModal.prototype, "id", void 0);
__decorate([
    Watch('paymentList', { deep: true })
], CheckoutModal.prototype, "paymentListHandler", null);
__decorate([
    Watch('data.discount', { deep: true })
], CheckoutModal.prototype, "discountWatcher", null);
__decorate([
    Watch('data.services', { deep: true })
], CheckoutModal.prototype, "servicesWatcher", null);
CheckoutModal = __decorate([
    Component({
        methods: {
            ...mapActions('appointment', { updateAppointment: 'patch' }),
            ...mapActions('customers', { updateCustomer: 'patch' }),
            ...mapActions('invoices', ['create']),
            ...mapActions('cart', { removeFromCart: 'remove', fetchCustomerCart: 'find' })
        },
        computed: {
            ...mapGetters('cart', { getCustomerCart: 'find' }),
        },
        components: {
            InvoiceModal,
            Payments,
            User: UserComponent,
            Money,
            Modal,
            Avatar,
            MoneyField,
            TeamSelect,
            DatePicker,
            AddItemModal,
            CustomSwitch,
            QuantityField,
            DiscountField,
            PaymentResultForm,
            ConfirmationModal,
            AppointmentNotification,
        },
        mixins: [modalMixins],
        filters: { duration }
    })
], CheckoutModal);
export default CheckoutModal;
